import React from 'react';

const SectionRightFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#010101"
            d="M12 20h8v-4h-8v4zM4 10v4h16v-4H4zM4 4v4h16V4H4z"
        />
    </svg>
);

SectionRightFillSvg.displayName = 'SectionRightFillSvg';
export default SectionRightFillSvg;
